function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Support-Panel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "02-Dashboard---B1-Partner",
  transform: "translate(-800.000000, -638.000000)"
}, React.createElement("g", {
  id: "Group-18",
  transform: "translate(340.000000, 623.000000)"
}, React.createElement("g", {
  id: "Group-27",
  transform: "translate(460.000000, 15.000000)"
}, React.createElement("g", {
  id: "Group-26",
  fill: "#EBEBEB"
}, React.createElement("rect", {
  id: "Selected-Copy-2",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 16
})), React.createElement("polyline", {
  id: "Path-5",
  stroke: "#666666",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(14.000000, 16.000000) scale(-1, 1) rotate(45.000000) translate(-14.000000, -16.000000) ",
  points: "18 20 10 20 10 12"
})))));

var SvgHover = function SvgHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hover.292a9c2d.svg";
export { ForwardRef as ReactComponent };